import React, { createContext, useContext, useTransition, useCallback } from 'react';
import { useRouter } from 'next/navigation';

const NavigationContext = createContext({
  isPending: false,
  handleNavigation: (newPage: string) => {},
});

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();

  const handleNavigation = useCallback((newPage: string) => {
    startTransition(() => {
      if (new URL(newPage, window.location.origin).pathname !== window.location.pathname) {
        router.push(newPage);
      }
    });
  }, [router]);

  return (
    <NavigationContext.Provider value={{ isPending, handleNavigation }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => useContext(NavigationContext);
